"use strict";
/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * ČVS - API
 * OpenAPI spec version: 1.1.529
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QualificationRequestType = void 0;
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.QualificationRequestType = {
    rozhodci: 'rozhodci',
    rozh_mez: 'rozh_mez',
    trener: 'trener',
    rozh_beach: 'rozh_beach',
    rozh_mez_beach: 'rozh_mez_beach',
    tren_beach: 'tren_beach',
    skolitel_tren: 'skolitel_tren',
    skolitel_rozh: 'skolitel_rozh',
    skolitel_beach: 'skolitel_beach',
};
